module.exports = __webpack_public_path__ + "static/img/10.fd194b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/10.png
// module id = Q/sp
// module chunks = 0